<img [src]="getImageUrl(type)" [alt]="getAlt()" [title]="getAlt()"/>
